<template>
<b-container fluid>
  <bo-page-title />
  <section id="home">
    <HeroSection :modulePage="modulePage" v-if="isList && moduleRole('hero')" />

    <b-tabs>
      <b-tab title="Page Settings">
        <b-card v-if="moduleRole('kontak')">
          <template #header>
            <h5 class="card-title">Benefit Yang Akan Didapatkan</h5>
          </template>

          <b-row>
            <b-col lg="6" v-for="(v, k) in benefit" :key="`benefit${k}`">
              <div class="how_it_work_wrap p-2">
                <b-row>
                  <b-col md="auto">
                    <div class="d-flex flex-column align-items-center">
                      <div class="bullet_number">
                        <p class="m-0">{{ k + 1 }}</p>
                      </div>

                      <div class="button-group d-flex flex-column align-items-center mt-2">
                        <b-button type="button" @click="openModal('modalBenefit', {...v, keyData: k})" variant="outline-info" class="btn-icon mr-0 rounded-pill" v-b-tooltip.hover title="Ubah Benefit">
                          <i class="ti-pencil"></i>
                        </b-button>
                        <b-button @click="deleteBenefit(v)" type="button" variant="outline-danger" class="btn-icon mt-1 mr-0 rounded-pill" v-b-tooltip.hover title="Hapus Benefit">
                          <i class="ti-trash"></i>
                        </b-button>
                      </div>
                    </div>
                  </b-col>
                  <div class="col-md-10">
                    <div class="desc_how_it_work">
                      <h3>{{ v.title }}</h3>
                      <p>
                        {{ v.description }}
                      </p>
                    </div>
                  </div>
                </b-row>
              </div>
            </b-col>

            <b-col lg="12" class="mt-3">
              <div class="text-center">
                <b-button variant="outline-primary" class="rounded-pill" @click="openModal('modalBenefit')"><i class="ti-plus"></i> Add Benefit</b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="SEO Settings" v-if="moduleRole('seo')">
        <SEOSection />
      </b-tab>
    </b-tabs>

    <b-modal id="modalBenefit" :title="(benefitRow.typeLabel == 'Added' ? 'Add' : 'Update') + ' Benefit'" size="md">
      <validation-observer v-slot="{ handleSubmit }" ref="VFormBenefit">
        <b-form @submit.prevent="handleSubmit(submitBenefit)">
          <b-row>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Title" v-model="benefitRow.title">
                <VValidate name="Title" v-model="benefitRow.title" :rules="{required: true, min: 3, regex:/^[^\s]+(\s+[^\s]+)*$/}" />
              </div>
            </b-col>
            <b-col md=12>
              <div class="form-group mb-2">
                <label class="control-label">Description <span class="text-danger">*</span></label>
                <b-form-textarea :rows="3" v-model="benefitRow.description"></b-form-textarea>
                <VValidate name="Description" v-model="benefitRow.description" :rules="{ required: true, min: 3 }" />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer="{close}">
        <div class="text-right">
          <b-button class="btn-rounded" variant="outline-secondary" @click="close">Cancel</b-button>
          <b-button type="button" @click="submitBenefit" class="btn-rounded ml-2" variant="primary">Save Changes</b-button>
        </div>
      </template>
    </b-modal>
  </section>
  
</b-container>
</template>

<script>
import GlobalVue from '@/libs/Global.vue'
import Gen from '@/libs/Gen'
import SEOSection from '@/components/SEOSection'
import HeroSection from '@/components/HeroSection'

export default {
  name: 'BoAboutUs',
  extends: GlobalVue,
  components: {
    SEOSection,
    HeroSection
  },
  mounted() {
    this.apiGet()
  },
  data() {
    return {
      productCatOpen: false,
      row: {},
      benefit: [],
      validation: {},
      showContent: null,

      benefitRow: {},
    }
  },
  computed: {},
  methods: {
    openModal(modal, data=null) {
      this.$set(this, 'benefitRow', {})
      this.$bvModal.show(modal)


      if(modal == "modalBenefit"){
        this.$set(this.benefitRow, 'typeLabel', 'Added')
        if(data) this.$set(this, 'benefitRow', { ...this.benefitRow, ...data, typeLabel: 'Updated' })
      }
    },
    deleteBenefit(data){
      this.$swal.fire({
        title: "Do You Really Want to Delete This Data",
        text: "Data that has been deleted can't recover anymore.",
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Delete Data",
        cancelButtonText: "No, Cancel",
      }).then(button => {
        if(button.isConfirmed){
          this.swalLoading()
          let benefit = this.benefit.filter(dtBenefit => dtBenefit.title != data.title)

          Gen.apiRest('/do/' + this.modulePage, 
              { data: { type: 'updateBenefit', ac_value: benefit, type_label: "Deleted" } }
            ).then(res => {
              if(res){
                this.$swal({
                  title: res.data.message,
                  icon: 'success',
                }).then(() => {
                  this.$bvModal.hide('modalBenefit')
                  this.apiGet()
                })
              }
            }).catch(err => {
              this.$swal({title: err.response.data.message, icon:'error'})
            })
        }
      })
    },
    showProductUpdate() {
      this.productCatOpen = true
    },
    closeProductForm() {
      this.productCatOpen = false
    },
    updateShowSection(value, slug, callback) {

      Gen.apiRest('/do/' + this.modulePage, {
        data: {
          type: 'updateShowSetting',
          value,
          slug
        }
      }).then(res => {
        if (res) {
          this.$swal({
            title: res.data.message,
            icon: 'success',
          }).then(() => {
            callback()
          })
        }
      }).catch(err => {
        this.$swal({
          title: err.response.data.message,
          icon: 'error'
        })
      })
    },
    submitBenefit(){
      this.$refs.VFormBenefit.validate().then(success => {
        if(!success) return 

        this.swalLoading()
        let benefit

        if(!this.benefit.length){
          benefit = [{ ...this.benefitRow, typeLabel: null }]
        } else {
          if(this.benefitRow.typeLabel == "Updated"){
            benefit = this.benefit.map((dtBenefit, kBenefit) => {
              if(kBenefit == this.benefitRow.keyData) return { ...this.benefitRow, keyData: null }
              return dtBenefit
            })
          } else {
            benefit = [...this.benefit, { ...this.benefitRow, typeLabel: null }]
          }
        }

        Gen.apiRest('/do/' + this.modulePage, 
            { data: { type: 'updateBenefit', ac_value: benefit, type_label: this.benefitRow.typeLabel } }
          ).then(res => {
            if(res){
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.$bvModal.hide('modalBenefit')
                this.apiGet()
              })
            }
          }).catch(err => {
            this.$swal({title: err.response.data.message, icon:'error'})
          })
      })
    },

    doDelete(v, params = {}, callback) {

      let id = v[params.idKey]
      let obj = params.obj || this.$route.meta.objName
      this.$swal({
        title: 'Delete this ' + obj + '?' || 'Data' + '?',
        text: "You won't be able to restore this data!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {

          this.swalLoading()

          Gen.apiRest("/do/" + this.modulePage, {
              data: {
                type: params.type,
                id: id
              }
            }, "POST")
            .then((resp = {}) => {
              this.$swal({
                title: resp.data.message || 'Deleted Successfully!',
                icon: 'success',
              }).then(() => {
                callback()
              })
            })
            .catch(err => {
              if (err) {
                err.statusType = err.status
                err.status = "error"
                err.title = err.response.data.title
                err.message = err.response.data.message
                err.messageError = err.message
              }
              this.doSetAlertForm(err)
            })
        }
      })
    },
    doSubmit() {
      this.$refs.VFormClient.validate().then(success => {
        if (!success) return

        this.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, {
          data: {
            type: 'updateDescription',
            ...this.row
          }
        }).then(res => {
          if (res) {
            this.$swal({
              title: res.data.message,
              icon: 'success',
            }).then(() => {
              this.apiGet()
              this.productCatOpen = false
            })
          }
        }).catch(err => {
          this.$swal({
            title: err.response.data.message,
            icon: 'error'
          })
        })
      })
    },
  },
  watch: {
    $route() {
      this.apiGet()
    },
  }
}
</script>

<style scoped>
.sect-heading__line {
  display: inline-block;
  width: 180px;
  height: 12px;
  border-radius: 20px;
  position: relative;
}

.sect-heading__line::before {
  content: '';
  position: absolute;
  top: 0;
  height: 60%;
  left: 60px;
  right: 60px;
  border-radius: 10px;
  background-color: #1AAAA2;
}
</style>
